import { useEffect } from 'react';

const AdSenseScript = () => {
  useEffect(() => {
    if (document.querySelector('script[src*="adsbygoogle.js"]')) return;

    (window as any).adsbygoogle = (window as any).adsbygoogle || [];

    const script = document.createElement('script');
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7610908742964821';
    script.async = true;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);

  }, []);

  return null;
};

export default AdSenseScript;
